import { Button, Icon, Flex, Tooltip } from '@servicetitan/anvil2';
import PhoneIcon from '@servicetitan/anvil2/assets/icons/material/round/phone.svg';
import React from 'react';
import styles from './SpeedToLeadCallButton.module.css';

export interface SpeedToLeadCallButtonProps {
  customerName: string;
  onCall: () => void;
  onBookJob: () => void;
  disabled: boolean;
  showBookJob: boolean;
  isCallConnected?: boolean;
  isCallEnded?: boolean;
}

export const SpeedToLeadCallButton: React.FC<SpeedToLeadCallButtonProps> = ({
  customerName,
  onCall,
  onBookJob,
  disabled,
  showBookJob,
  isCallConnected = false,
  isCallEnded = false,
}) => {
  const showConnected = isCallConnected && !isCallEnded;

  const buttonLabel = showConnected ? 'Connected' : `Call ${customerName}`;

  const callButton = (
    <Button
      appearance={'primary'}
      onClick={onCall}
      disabled={disabled}
      className={styles.callButton}
    >
      <Flex
        direction='row'
        gap={1}
        alignItems='center'
        className={
          disabled ? styles.callButtonDisabled : styles.callButtonContent
        }
      >
        <Icon
          svg={PhoneIcon}
          size='small'
          color={disabled ? 'muted' : 'white'}
        />
        {buttonLabel}
      </Flex>
    </Button>
  );

  return (
    <Flex direction='row' gap={2} alignItems='center'>
      {showBookJob && (
        <Button appearance='secondary' onClick={onBookJob}>
          Book Job
        </Button>
      )}
      {isCallEnded ? (
        <Tooltip>
          <Tooltip.Content>
            Only one call per task is allowed. Log the outcome and claim a new
            task to continue.
          </Tooltip.Content>
          <Tooltip.Trigger>{callButton}</Tooltip.Trigger>
        </Tooltip>
      ) : (
        callButton
      )}
    </Flex>
  );
};
